import { TranslatePipe } from "@ngx-translate/core";
import { AngularSvgIconModule } from "angular-svg-icon";

import { ChangeDetectionStrategy, Component } from "@angular/core";
import { RouterModule } from "@angular/router";

import { NavigationComponent } from "../../../../../components/common/navigation/navigation";
import { ServiceIcon } from "../../../../../components/subscription-detail/service-icon/service-icon";
import { ENV } from "../../../../app.runtime";
import { LANGUAGE_STORAGE_KEY } from "../../../../constants";

@Component({
  selector: "navigation-news",
  templateUrl: "./navigation-news.component.html",
  styleUrls: ["../../../../../components/common/navigation/navigation.scss"],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [AngularSvgIconModule, RouterModule, ServiceIcon, TranslatePipe],
})
export class NavigationNews extends NavigationComponent {
  // Fixme: probably a very bad idea to derive this from NavigationComponent
  protected newsUrl = ENV.NWD_NEWS_URL;
  protected dashboardUrl = ENV.NWD_DASHBOARD_URL;

  protected switchLanguage(lang: string): void {
    this.translate.use(lang);
    localStorage.setItem(LANGUAGE_STORAGE_KEY, lang);
  }
}
